// import store from "@/state/store";
import adminRouter from "./adminRouter";
import administratorRoute from "./administratorRouter";
import operatorRouter from "./operatorRouter";
import vendorRouter from "./vendorRouter";
import wargaRoutes from "./wargaRoutes";
import { tokenManager } from "@/lib/tokenManager";
// import store from "@/state/store";
// import authRouter from "./authRouter";
// const isLoggedIn = localStorage.getItem("jwt") && localStorage.getItem("user");
export default [
  adminRouter,
  administratorRoute,
  operatorRouter,
  vendorRouter,
  wargaRoutes,
  // authRouter,
  // ANCHOR Default
  {
    path: "/",
    name: "default",
    meta: {
      title: "Home",
      beforeResolve(routeTo, routeFrom, next) {
        const loggedIn = tokenManager.getToken() && localStorage.getItem("user");
        return next({ name: loggedIn ? "dashboard" : "landing-page" });
      },
    },
    // component: () => import("../views/custom/dashboard/index.vue"),
  },
  // ANCHOR Login
  {
    path: "/login",
    name: "login",
    component: () => import("../views/custom/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        const loggedIn = tokenManager.getToken() && localStorage.getItem("user");
        if (loggedIn) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      },
    },
  },
  // ANCHOR Register
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/custom/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        const loggedIn = tokenManager.getToken() && localStorage.getItem("user");
        if (loggedIn) {
          // Redirect to the home page instead
          next({ name: "dashboard" });
        } else {
          // Continue
          next();
        }
      },
    },
  },
  // ANCHOR Logout
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          // Import axios dynamically to avoid circular dependencies
          const { default: api } = await import("@/lib/axios");
          
          // Call logout API to delete session/device from database and clear cookies
          await api.post("/api/logout", {}, {
            headers: {
              'Authorization': `Bearer ${tokenManager.getToken()}`
            }
          });
        } catch (error) {
          console.error("Logout API error:", error);
          // Continue with logout even if API call fails
        } finally {
          // Clear token from tokenManager
          tokenManager.clearToken();
          
          // Clear all session items, but preserve remembered credentials
          const rememberedNIK = localStorage.getItem("rememberedNIK");
          localStorage.clear();
          if (rememberedNIK) {
            localStorage.setItem("rememberedNIK", rememberedNIK);
          }
          
          next();
        }
      },
    },
    component: () => import("../views/custom/account/logout"),
  },
  // ANCHOR Forgot Password
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/custom/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        const loggedIn = tokenManager.getToken() && localStorage.getItem("user");
        if (loggedIn) {
          // Redirect to the home page instead
          next({ name: "dashboard" });
        } else {
          // Continue
          next();
        }
      },
    },
  },
  // ANCHOR Verify Email
  {
    path: "/verify-email",
    name: "verify-email",
    component: () => import("../views/custom/account/verify-email.vue"),
    meta: {
      title: "Verify Email",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
       const user = JSON.parse(localStorage.getItem("user"));
       const loggedIn = tokenManager.getToken() && user;
        if (loggedIn) {
          if (user.email_verification_required == false) {
            next({ name: "dashboard" });
          } else {
            next();
          }
        } else {
          next({ name: "login" });
        }
      },
    },
  },
  {
    path: "/waiting-verification",
    name: "waiting-verification",
    component: () => import("../views/custom/account/waiting-verification.vue"),
    meta: {
      title: "Waiting Verification",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
       const user = JSON.parse(localStorage.getItem("user"));
       const loggedIn = tokenManager.getToken() && user;
        if (loggedIn) {
          if (user.account_verified === true) {
            next({ name: "dashboard" });
          } else {
            next();
          }
        } else {
          next({ name: "login" });
        }
      },
    },
  },
  // ANCHOR Update Profile
  {
    path: "/update-profile",
    name: "update-profile",
    component: () => import("../views/custom/account/update-profile.vue"),
    meta: {
      title: "Update Profile",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
       const user = JSON.parse(localStorage.getItem("user"));
       const loggedIn = tokenManager.getToken() && user;
        if (loggedIn) {
          if (user.account_verified === 0) {
            next();
          } else {
            next({ name: "dashboard" });
          }
        } else {
          next({ name: "login" });
        }
      },
    },
  },
  // ANCHOR Delete Account
  {
    path: "/delete-account",
    name: "delete-account",
    component: () => import("../views/custom/account/delete-account-form.vue"),
    meta: {
      title: "Hapus Akun",
    },
  },
  // ANCHOR Dashboard
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
      verificationRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   const user = JSON.parse(localStorage.getItem("user"));
      //   console.log(user);
      //   next();
      // }
      // roles: [
      //   "administrator",
      //   "admin",
      //   "operator_kabupaten",
      //   "vendor",
      //   "tenaga_fasilitator_lapangan",
      //   "user",
      // ],
    },
    component: () => import("../views/custom/dashboard/index.vue"),
  },
  // ANCHOR Forbidden
  {
    path: "/forbidden",
    name: "forbidden",
    component: () => import("../views/custom/forbidden.vue"),
    meta: {
      title: "Forbidden",
    },
  },
    // ANCHOR Landing Page
  {
    path: "/landing-page",
    name: "landing-page",
    meta: {
      title: "Landing Page",
      beforeResolve(routeTo, routeFrom, next) {
        // Check if user is already logged in
        const user = localStorage.getItem("user");
        const token = tokenManager.getToken();

        if (user && token) {
          // User is logged in, redirect to dashboard
          next({ name: "dashboard" });
        } else {
          // User is not logged in, allow access to landing page
          next();
        }
      },
    },
    component: () => import("../views/landing/index"),
  },
  // ANCHOR Kebijakan Privasi (Public)
  {
    path: "/kebijakan-privasi",
    name: "kebijakan-privasi",
    meta: {
      title: "Kebijakan Privasi",
    },
    component: () => import("../views/landing/kebijakan-privasi.vue"),
  },
  // ANCHOR Public GIS
  {
    path: "/gis",
    name: "gis-public",
    meta: {
      title: "Peta Sebaran Rumah",
    },
    component: () => import("../views/custom/public/gis/index.vue"),
  },
]